// Golf Hustler SETTINGS page (App preferences) — themed placeholder surface.
export default function GAppSettings() {
  return (
    <div className="hh-page">
      <h1 className="hh-page-title">Settings</h1>
      <p className="hh-page-sub">App preferences.</p>
      <div className="hh-settings-card">
        <div className="hh-set-row"><span>Theme</span><span className="hh-set-val">Golf Hustler</span></div>
        <div className="hh-set-row"><span>Account</span><span className="hh-set-val">Apple &amp; Google sign-in — coming soon</span></div>
        <div className="hh-set-row"><span>Sync</span><span className="hh-set-val">Saved games hand off to the Golf Hustler app</span></div>
      </div>
    </div>
  )
}
